export default __webpack_public_path__ + "static/media/filter_sections_light.74dd7023.svg";